module.exports = __webpack_public_path__ + "ae5881269a7f526ea24cb103bd8552bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/news/img1_1.jpg
// module id = 396
// module chunks = 0